import { Component, OnInit } from '@angular/core';
import { toggleAnimation } from 'src/app/shared/animations';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { AppService } from '../../../shared/service/app/app.service';
import { AnalitycsService } from 'src/app/shared/service/analitycs.service';
import moment from 'moment';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonService } from './../../../shared/service/common/common.service';
import { UserDTO, UserSendCodeDTO } from './../../../shared/dto/user.dto';
import { AlertService } from '../../../shared/service/common/alert.service';
import { CountryCmbDto } from 'src/app/shared/dto/country.dto';
import { CityDto, StateDto } from 'src/app/shared/dto/city.dto';
import { AuthService } from '../../../shared/service/auth/auth.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-register',
  templateUrl: 'register.component.html',
  styleUrls: ['register.component.scss'],
  animations: [toggleAnimation],
})
export class CoverRegisterComponent implements OnInit {
  user: UserSendCodeDTO | null = null;
  userComplete: UserDTO | null = null;
  registerForm: FormGroup;
  isModalVisible: boolean = false;
  isDarkMode: boolean = false;
  interval: any;
  spanish: boolean = true;
  store: any;
  currYear: number = new Date().getFullYear();
  currentImage: string = '';
  formGroup: FormGroup;
  departments: Array<{ name: string; cities: string[] }> = [];
  //   cities: string[] = [];

  countries: CountryCmbDto[] = [];
  cities: CityDto[] = [];
  states: StateDto[] = [];
  listVehicleTypesAll: any[] = [];

  constructor(
    public translate: TranslateService,
    public storeData: Store<any>,
    public router: Router,
    private appSetting: AppService,
    private analitycs: AnalitycsService,
    private fb: FormBuilder,
    private commonService: CommonService,
    private alertService: AlertService,
    private authService: AuthService,
  ) {
    this.formGroup = this.fb.group({
      vehiclePlate: [''],
      countryCode: [''],
    });
    this.initStore();
    //Reactive-Form
    this.registerForm = this.fb.group(
      {
        firstName: ['', Validators.required],
        lastName: ['', Validators.required],
        email: ['', [Validators.required, Validators.email]],
        //   typeOfId: ['', Validators.required],
        //   documentNumber: ['', [Validators.required, Validators.pattern(/^\d+$/)]], //only numbers
        countryCode: ['CO', Validators.required],
        departament: ['', Validators.required],
        city: ['', Validators.required],
        phone: ['', Validators.required],
        password: ['', [Validators.required, Validators.minLength(6)]],
        confirmPassword: ['', Validators.required],
        //   vehiclePlate: ['', [Validators.required, Validators.maxLength(6), Validators.pattern('^[A-Za-z0-9]+$')]],
        //   vehicleModel: ['', Validators.required],
        termsAccepted: [false, Validators.requiredTrue],
      },
      { validators: this.passwordsMatchValidator },
    );
  }
  async initStore() {
    this.storeData
      .select((d) => d.index)
      .subscribe((d) => {
        this.store = d;
      });
  }

  ngOnInit() {
    // Verificar si el usuario ya tiene un token y redirigirlo al perfil
    const token = localStorage.getItem('secTkn');
    if (token) {
      console.log('El usuario ya tiene un token, redirigiendo al perfil');
      this.authService.setAuthenticated(true);

      // Mostrar mensaje de bienvenida antes de redirigir
      Swal.fire({
        icon: 'success',
        toast: true,
        title: '¡Bienvenido de nuevo!',
        text: 'Ya tienes una cuenta. Redirigiendo a tu perfil...',
        position: 'top',
        timer: 2000,
        timerProgressBar: true,
        showConfirmButton: false,
      }).then(() => {
        this.router.navigate(['/profile']);
      });
      return;
    }

    // Registrar evento de analítica
    this.analitycs.logEvent('vista_registro', {
      pantalla: 'registro',
      accion: 'vista',
      timestamp: moment().format('YYYY-MM-DD HH:mm:ss'),
      plataforma: 'web',
    });

    // Cargar datos necesarios para el formulario
    this.getAvailableCountriesToCmb();
    this.getlistVehicleTypesAll();
    this.storeData
      .select((state) => state.index.locale)
      .subscribe((locale) => {
        this.spanish = locale === 'es';

        // Actualizar la imagen según el idioma
        this.currentImage = locale === 'en' ? '../../assets/images/pit1inglish.jpg' : '../../assets/images/pit.jpg';
      });
    localStorage.setItem('light', 'dark');
    this.storeData
      .select((state) => state.index.theme)
      .subscribe((theme) => {
        this.isDarkMode = theme === 'dark';
      });
  }

  async getAvailableCountriesToCmb() {
    this.countries = await this.commonService.getAvailableCountriesToCmb();
    this.onPaisChange();
  }

  async onPaisChange() {
    this.states = await this.commonService.getAvailableStatesByCountryCode(this.registerForm.get('countryCode')?.value);
    // console.log(this.countries);
    // console.log(this.states);
  }

  async getlistVehicleTypesAll() {
    const result = (await this.commonService.getlistVehicleTypesAll()).map((option: any) => {
      return {
        _id: option._id,
        name: option.name.es,
      };
    });

    this.listVehicleTypesAll = result;
  }

  async getAvailableCityByStateCountryCode() {
    this.cities = [];
    const result = await this.commonService.getAvailableCityByStateCountryCode(
      this.registerForm.get('countryCode')?.value,
      this.registerForm.get('departament')?.value,
    );
    this.cities = result;
  }
  onDepartamentoChange() {
    this.registerForm.patchValue({ ciudad: '' });
  }

  async openModal() {
    this.analitycs.logEvent('abrir_modal_de_verificacion_de_codigo', {
      pantalla: 'register',
      accion: 'click',
      timestamp: moment().format('YYYY-MM-DD HH:mm:ss'),
      plataforma: 'web',
    });

    // Verifica si el formulario es válido
    if (!this.registerForm.valid) {
      console.error('Formulario inválido', this.getInvalidControls());
      this.registerForm.markAllAsTouched();
      return;
    }

    try {
      this.alertService.showLoading('Enviando información...');
      this.user = {
        email: this.registerForm.value.email,
        phone: {
          code: this.registerForm.value.countryCode,
          number: `${this.registerForm.value.phone}`,
        },
      };

      this.userComplete = {
        // document_number: this.registerForm.value.documentNumber,
        email: this.registerForm.value.email,
        name: {
          first_name: this.registerForm.value.firstName,
          last_name: this.registerForm.value.lastName,
          full_name: `${this.registerForm.value.firstName} ${this.registerForm.value.lastName}`,
        },
        country_code: this.registerForm.value.countryCode,
        department_code: this.registerForm.value.departament,
        city_code: this.registerForm.value.city,
        password: this.registerForm.value.password,
        // document_type: this.registerForm.value.typeOfId,
        phone: {
          code: this.registerForm.value.countryCode,
          number: this.registerForm.value.phone,
        },
      };

      const rsp = await this.commonService.sendSmsCode(this.user);
      console.log(rsp);
      this.alertService.close();
      this.isModalVisible = true;
    } catch (error) {
      console.error('Error al enviar el código SMS:', error);
      this.alertService.close();
    }
  }
  getInvalidControls() {
    const invalidControls: { [key: string]: any } = {};
    Object.keys(this.registerForm.controls).forEach((key) => {
      const control = this.registerForm.controls[key];
      if (control.invalid) {
        invalidControls[key] = control.errors;
      }
    });
    return invalidControls;
  }

  closedModal() {
    this.analitycs.logEvent('cerrar_modal_de_verificacion_de_codigo', {
      pantalla: 'registro',
      accion: 'click',
      timestamp: moment().format('YYYY-MM-DD HH:mm:ss'),
      plataforma: 'web',
    });

    this.isModalVisible = false;
  }
  networks() {
    this.analitycs.logEvent('redes_sociales', {
      pantalla: 'register',
      accion: 'click',
      timestamp: moment().format('YYYY-MM-DD HH:mm:ss'),
      plataforma: 'web',
    });
  }
  GoToLogin() {
    this.analitycs.logEvent('ir_a_login', {
      pantalla: 'register',
      accion: 'click',
      timestamp: moment().format('YYYY-MM-DD HH:mm:ss'),
      plataforma: 'web',
    });
    this.router.navigate(['../login']);
  }
  onInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.toUpperCase();
    this.formGroup.get('vehiclePlate')?.setValue(input.value, { emitEvent: false });
  }
  passwordsMatchValidator(form: AbstractControl): null | object {
    const password = form.get('password')?.value;
    const confirmPassword = form.get('confirmPassword')?.value;
    if (password !== confirmPassword) {
      form.get('confirmPassword')?.setErrors({ mismatch: true });
      return { mismatch: true };
    } else {
      return null;
    }
  }
}
